const steps = [
  { num: '01', title: 'Conocemos tu proyecto', desc: 'Entendemos tus necesidades, el contexto y el terreno.' },
  { num: '02', title: 'Diseñamos', desc: 'Desarrollamos el concepto y el proyecto arquitectónico.' },
  { num: '03', title: 'Visualizamos', desc: 'Creamos renders e imágenes para ver el resultado antes de construir.' },
  { num: '04', title: 'Desarrollamos', desc: 'Generamos el proyecto ejecutivo y la documentación para trámites.' },
  { num: '05', title: 'Construimos', desc: 'Ejecutamos la obra con supervisión y coordinación.' },
];

export default function Process() {
  return (
    <section id="proceso" className="bg-white text-neutral-900">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="mb-14 md:mb-20 reveal">
          <p className="overline text-neutral-400">Proceso</p>
          <h2 className="font-display font-medium tracking-tightest text-[clamp(2rem,5vw,4.5rem)] mt-4 max-w-3xl">
            Cinco pasos, un solo proceso
          </h2>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-6 left-0 right-0 h-px bg-neutral-200"></div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-6">
            {steps.map((s) => (
              <div key={s.num} className="reveal">
                <div className="relative w-12 h-12 flex items-center justify-center bg-neutral-900 text-white mb-6">
                  <span className="overline">{s.num}</span>
                </div>
                <h3 className="font-display text-lg font-medium tracking-tightest">{s.title}</h3>
                <p className="text-sm text-neutral-500 mt-3 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}